export const USTerms = [
  {
    id: 'US63',
    label: '5 Years for $63.00',
    value: 63,
    addlText: '($12.60/yr)',
    length: 5,
  },
  {
    id: 'US43',
    label: '3 Years for $43.00',
    value: 43,
    addlText: '($14.33/yr)',
    length: 3,
  },
  {
    id: 'US16',
    label: '1 Year for $16.00',
    value: 16,
    addlText: '($16.00/yr)',
    length: 1,
  },
  {
    id: 'US12',
    label: '1 Year with Automatic Renewal',
    value: 12,
    addlText: '($12 first year - Save 25%)',
    autoRenew: true,
  },
];

export const InternationalTerms = [
  {
    id: 'CAN17',
    label: 'Canada, 1 Year/US$17',
    value: 17,
    length: 1,
  },
  {
    id: 'MEX17',
    label: 'Mexico, 1 Year/US$17',
    value: 17,
    length: 1,
  },
  {
    id: 'OTH28',
    label: 'Other Countries, 1 Year/US$28',
    value: 28,
    length: 1,
  },
];



// WEBPACK FOOTER //
// ./src/app/components/Terms/terms.js